export class ImportError{
    constructor(public index: number, public datasource: string, public error: string ){}
}